import { render } from "./GoalsSummary.vue?vue&type=template&id=b4dc9dca&scoped=true"
import script from "./GoalsSummary.vue?vue&type=script&lang=js"
export * from "./GoalsSummary.vue?vue&type=script&lang=js"

import "./GoalsSummary.vue?vue&type=style&index=0&id=b4dc9dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4dc9dca"]])

export default __exports__